import { render, staticRenderFns } from "./LeavingRegist.vue?vue&type=template&id=6143029a&scoped=true"
import script from "./LeavingRegist.vue?vue&type=script&lang=js"
export * from "./LeavingRegist.vue?vue&type=script&lang=js"
import style0 from "./LeavingRegist.vue?vue&type=style&index=0&id=6143029a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6143029a",
  null
  
)

export default component.exports